
import React from 'react'

import { Button, Input, Table } from 'antd'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'

import { EmptyPersonalizado } from './EmptyPersonalizado'
import useReporteEstadoExamen from '../hooks/adminexamen/useReporteEstadoExamen'
import { Toaster } from 'react-hot-toast'
import { buscar_cantidad_aspirantes } from '../functions/arreglos'


const ReporteEstadoExamen = () => {

  const { datosReporteEstadoExamen, loading, columns, setTextoBuscar, textoBuscar, traerDatosReporteEstadoExamen } = useReporteEstadoExamen()

  var cantidad_aspirantes = buscar_cantidad_aspirantes( datosReporteEstadoExamen )

  return (
    <>
      <Table
        loading = { loading }
        columns = { columns }
        title = { () => (
            <>
              <h1>{ cantidad_aspirantes }</h1>
              <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
              <div style={{ marginTop: 10 }}>
                <Button shape="circle" type='primary' icon={<ReloadOutlined />} onClick={traerDatosReporteEstadoExamen}/>
              </div>
            </>
        )}
        rowKey = "pk_estado_examen"
        showSorterTooltip = { false }
        dataSource = { datosReporteEstadoExamen }
        locale = {{ emptyText: <EmptyPersonalizado/> }}
      />
      <Toaster/>
    </>
  )
}

export default ReporteEstadoExamen
